import { gql } from '@apollo/client';
import { BenchmarkReportCategory } from 'spw-redux/modules/benchmark-reports/types';
import { graphqlClient } from './utils';

export const updateBenchmarkReportCategoryApi = (
  benchmarkReportCategories: BenchmarkReportCategory[]
) => {
  return graphqlClient.query<{ reportCategories: BenchmarkReportCategory[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      mutation UpdateBenchmarkReportCategories(
        $benchmarkReportCategories: [BenchmarkReportCategoryArgs]!
      ) {
        reportCategories: updateBenchmarkReportCategories(
          benchmarkReportCategories: $benchmarkReportCategories
        ) {
          id
          name
          color
          gradientColorIndex
          defaultCategory
        }
      }
    `,
    variables: {
      benchmarkReportCategories,
    },
  });
};
